import React, { Component } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import Header from "./Header";
import Navbar from "./Navbar";
import Footer from "./Footer";
import NewConstants from "./NewConstants";

const stripHtml = (value = "") => value.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();

export default class Blogs extends Component {
  state = {
    blogs: [],
    loading: true,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    Axios.post(NewConstants.postUrls.blogs, { page: 1, limit: 100 })
      .then((res) => {
        const responseData = res && res.data && res.data.data;
        this.setState({
          blogs: (responseData && responseData.rows) || [],
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          blogs: [],
          loading: false,
        });
      });
  }

  render() {
    const { blogs, loading } = this.state;

    return (
      <div>
        <Header />
        <Navbar />
        <div className="breadcumb-area bg-img" style={{ position: "relative" }}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/77/Medlibrary.jpg"
            alt="Students studying together in a busy library reading room."
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 0,
            }}
          />
          <div className="bradcumbContent">
            <h2>Blogs</h2>
          </div>
        </div>

        <section className="blog-area section-padding-100">
          <div className="container">
            <div className="row">
              {loading ? (
                <div className="col-12 text-center">
                  <h5>Loading blogs...</h5>
                </div>
              ) : blogs.length ? (
                blogs.map((blog) => (
                  <div className="col-12 col-md-6 col-lg-4" key={blog.id}>
                    <div
                      className="single-blog-post mb-100 wow fadeInUp"
                      data-aos="fade-up"
                      onClick={() => this.props.history.push(`/blogs/${blog.id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      {blog.image_path ? (
                        <img
                          src={NewConstants.imageUrl + blog.image_path}
                          alt={blog.img_alt_text || blog.title}
                          style={{ width: "100%", height: "240px", objectFit: "cover" }}
                        />
                      ) : null}
                      <Link
                        className="post-title"
                        to={`/blogs/${blog.id}`}
                        style={{ color: "black", textDecoration: "none" }}
                      >
                        {blog.title}
                      </Link>
                      <div className="post-meta">
                        <p style={{ color: "black" }}>
                          {(blog.meta_description || stripHtml(blog.blog_content).slice(0, 140)) + "..."}
                        </p>
                      </div>
                      <Link
                        to={`/blogs/${blog.id}`}
                        className="btn academy-btn btn-sm"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center">
                  <h5>No blogs found.</h5>
                </div>
              )}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}
